import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const TenantLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      // Standard email/password login
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) {
        setMessage(error.message);
      } else {
        // After login, look up user's tenant
        const { data: tenantData } = await supabase.functions.invoke('user-tenant-lookup', {
          body: { userId: data.user.id }
        });
        
        if (tenantData?.tenant) {
          // Cache user profile and tenant data
          const userProfile = {
            id: data.user.id,
            email: data.user.email,
            tenant: tenantData.tenant,
            role: tenantData.role,
            lastLogin: new Date().toISOString()
          };
          
          localStorage.setItem('userProfile', JSON.stringify(userProfile));
          localStorage.setItem('tenantData', JSON.stringify(tenantData.tenant));
          
          // Redirect to appropriate dashboard
          window.location.href = '/owner-dashboard';
        } else {
          setMessage('No tenant found for this user');
        }
      }
    } catch (err) {
      setMessage('Login error: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: '60px 0' }}>
      <div className="container" style={{ maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password *</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        {message && (
          <div style={{ marginTop: '20px', padding: '10px', background: '#f8f9fa', borderRadius: '4px' }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default TenantLogin;